import permissions from "app/permissions";
import ListForeignLanguagesStudents from "./List";
import { ActivityServicePath, ASSIGNMENTS, FOREIGN_LANGUAGES, LEVELS } from "utils/constants";

export const resources = {
  isMenu: false,
  name: ActivityServicePath + "students/" + FOREIGN_LANGUAGES + "/" + LEVELS + "/" + ASSIGNMENTS,
  title: "Входни тестове",
  list: <ListForeignLanguagesStudents />,
  permission: permissions.canPreviewStudentsForeignLanguages,
};
